const readJson = (key, fallback) => {
  try {
    return JSON.parse(localStorage.getItem(key)) || fallback;
  } catch {
    return fallback;
  }
};

export const getStats = () => readJson("stats", { correctGuesses: 0 });

export const saveStats = (stats) =>
  localStorage.setItem("stats", JSON.stringify(stats));

export const getSeenWords = () => readJson("seenWords", []);

export const saveSeenWords = (words) =>
  localStorage.setItem("seenWords", JSON.stringify(words));

export const getContributorId = () => {
  const saved = localStorage.getItem("contributorId");

  if (saved) return saved;

  const id =
    typeof crypto !== "undefined" && crypto.randomUUID
      ? crypto.randomUUID()
      : `${Date.now()}-${Math.random().toString(16).slice(2)}`;

  localStorage.setItem("contributorId", id);
  return id;
};
